<script>
import SimpleList from '../simple-list';

export default {
  extends: SimpleList,

  methods: {
    /**
     * @return {boolean}
     */
    isItemsEqual(item1, item2) {
      return _.get(item1, 'model.id') === _.get(item2, 'model.id');
    },
  },
}
</script>
